export function Footer({ embedded = false }) {
  // Hide footer when embedded in another site
  if (embedded) return null;
  
  return (
    <footer className="bg-[#F5F1E8] border-t border-[#E5E0D5] mt-12">
      <div className="max-w-7xl mx-auto px-4 py-6 text-sm text-[#666] grid md:grid-cols-3 gap-4">
        <div>
          <strong className="text-[#6A7359]">Ready To Paint Cabinet Doors</strong>
          <p>Varcroft & Bianco | 25+ years</p>
        </div>
        <div>
          <strong className="text-[#6A7359]">Location</strong>
          <p>733 County Road 8, Warsaw, ON</p>
        </div>
        <div>
          <strong className="text-[#6A7359]">Contact</strong>
          <p>(705) 652-3520</p>
        </div>
      </div>
    </footer>
  );
}
